export default __webpack_public_path__ + "static/media/carou4.73764223.jpg";